module.exports = __webpack_public_path__ + "img/home-questions.c06947fa.jpg";